import { Component, OnInit, ViewChild, QueryList, Query, ElementRef } from '@angular/core';
import { NavController } from '@ionic/angular';
import { GlobalVars } from '../../../providers/globalVars';
import { AngularFireDatabase } from '@angular/fire/database';
import { IonContent } from '@ionic/angular';
@Component({
  selector: 'app-levelinfo',
  templateUrl: './levelinfo.page.html',
  styleUrls: ['./levelinfo.page.scss'],
})
export class LevelinfoPage implements OnInit {

  currentlvl:number = 0;
  levels: any[] = [];
  gomylv: any;
  gomylvVal: any;

  constructor(public gv: GlobalVars,public afDB: AngularFireDatabase, public navCtrl:NavController) {
    this.currentlvl = gv.ulvl;
    afDB.database.ref('/level').once('value').then(lvls=>{
       lvls.forEach(level => {
           this.levels.push(level.val());
       });
   })
  }

  @ViewChild(IonContent) private content: IonContent;
  @ViewChild('comehere') private comehere;

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.gomylv = (this.comehere.nativeElement.classList[0]).split('index_')[1];
    this.gomylvVal = (this.gomylv-1) * 118; //118은 하나당 높이(margin 포함)
    // console.log(this.gomylv.nativeElement.offsetTop);
    // this.content.scrollToBottom(1500);
    setTimeout(_=>{
      // this.content.scrollToPoint(0, this.gomylv.nativeElement.offsetTop*100, 1500);
      this.content.scrollToPoint(0, this.gomylvVal, 500);
    },300);
    
  }

  

}
